<div
  bsModal
  #dlg="bs-modal"
  class="modal my-modal-wrapper fade"
  tabindex="100"
  role="dialog"
  aria-labelledby="filters"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <form (ngSubmit)="delegate.closeFilterDlg(this, filters)" #formRef="ngForm">
        <div class="modal-body" style="height: 650px; overflow-y: auto">
          <ng-content></ng-content>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary pull-left" (click)="filters.reset()">
            Reset
          </button>
          <button type="button" class="btn btn-warning" (click)="dlg.hide()">Cancel</button>
          <button type="submit" class="btn btn-primary">Apply</button>
        </div>
      </form>
    </div>
  </div>
</div>
